import React from 'react';

interface AdditionalImagesUploadProps {
    selectedAdditionalFiles: (File | null)[];
    setSelectedAdditionalFiles: (files: (File | null)[]) => void;
}

const AdditionalImagesUpload: React.FC<AdditionalImagesUploadProps> = ({ selectedAdditionalFiles, setSelectedAdditionalFiles }) => {
    const handleAdditionalFileChange = (index: number, event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files) {
            const newFiles = [...selectedAdditionalFiles];
            newFiles[index] = event.target.files[0];
            setSelectedAdditionalFiles(newFiles);
        }
    };

    return (
        <div className="mb-6">
            <label className="block mb-2">추가 이미지 업로드 (최소 3장)</label>
            <div className="grid grid-cols-5 gap-2">
                {Array.from({ length: 6 }).map((_, index) => (
                    <div key={index} className="relative">
                        {selectedAdditionalFiles[index] ? (
                            <>
                                <img
                                    src={URL.createObjectURL(selectedAdditionalFiles[index] as File)}
                                    alt={`Additional preview ${index + 1}`}
                                    className="w-full h-24 object-cover border rounded-md"
                                />
                                <button
                                    type="button"
                                    onClick={() => {
                                        const newFiles = [...selectedAdditionalFiles];
                                        newFiles[index] = null; // 해당 인덱스의 파일을 제거
                                        setSelectedAdditionalFiles(newFiles);
                                    }}
                                    className="absolute top-0 right-0 bg-red-500 text-white rounded-full w-6 h-6 flex items-center justify-center"
                                >
                                    &times;
                                </button>
                            </>
                        ) : (
                            <label className="w-full h-24 border rounded-md flex items-center justify-center text-gray-400 cursor-pointer">
                                <input
                                    type="file"
                                    onChange={(event) => handleAdditionalFileChange(index, event)}
                                    className="hidden"
                                    accept="image/*"
                                />
                                Upload Image
                            </label>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default AdditionalImagesUpload;
